import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from "ngx-spinner";
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { SessionDataDialogBoxComponent } from '../session-data-dialog-box/session-data-dialog-box.component';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-session-data',
  templateUrl: './session-data.component.html',
  styleUrls: ['./session-data.component.scss']
})
export class SessionDataComponent implements OnInit {
  displayedColumns = ['Session Number', 'Session Year', 'Session Code', 'Session Name', 'Session Default', 'Session Status'];
  SessionForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  isread = false;
  showSubmitButton = true;
  isreadonly = false;
  sessionList: any;
  session: string;
  list;
  sessionform: any;
  SessionSearchForm;
  SessionList: any;
  filteredListSession: any;
  codeTypeList: any;
  filteredCodeType: any;
  isShowDiv=false;
  dialogRef: MatDialogRef<any>;
  desLabel: any;
  currentsession: string;
  userPermission:any;
  utp: any;
  sessCreate = true;
sessUpdate = true; 
pageSize = 10;
pageSizeOptions: number[] = [5, 10, 20];
currentPage = 1;
totalItems = 0;
setIntervalSearch: any;
  constructor(
    private modalPopupService: ModalpopService,
    public umsService: UmsService,
    private dialog: MatDialog, 
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute, private spinner:NgxSpinnerService) {
  }
  download(){
    const wwe = ['SnNo', 'SnYear', 'SnCode', 'SnName', 'SnDefault', 'SnStatus'];
    this.umsService.downloadFile(this.SessionList, 'jsontocsv', wwe);
  }
  MenuCode = 'new';
  ngOnInit(): void {
    
    window.scroll(0, 0);
    this.route.queryParams.subscribe(
      params => {
        this.MenuCode = params['MenuCode'];
        if(this.MenuCode == "switch-session"){
          this.submitButton = false;
        }
        else{
          this.submitButton = true;
        }
      }
    )
  
    let id = '';
    this.fetchCodeType(id);
    this.getSessionData();
    this.list = true;
    
    this.SessionSearchForm = this.fb.group({
      SearchString: new FormControl(''),
    });
    if(this.MenuCode == "switch-session"){
      this.submitButton = false;
    }
  }

  
  keypress(){
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.sessionList = [];
    let payload = {}
    payload['SearchString'] = this.SessionSearchForm.value['SearchString'];
    payload['PageSize'] = this.pageSize;
    // payload['PageNumber'] = this.currentPage;
    if (payload['SearchString'] === "") {
      payload['PageNumber'] = this.currentPage;
    } else {
      payload['PageNumber'] = 1;
    }
    this.umsService.searchSession(payload).subscribe(res => {
      if(res.status){
        this.sessionList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      }
      else{
        this.sessionList = [];
        this.totalItems = 0;
      }
     
      }, (ERROR: HttpErrorResponse) => {
        this.sessionList = [];
      });
    },1000)
   
  }
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    // const newPageIndex = Math.floor(event.pageSize * event.pageIndex / this.pageSize);
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getSessionData();
  }
  getSessionData() {
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = res.data;
      this.totalItems = res.data[0].TotalRecords;
     
    }, (ERROR: HttpErrorResponse) => {
      this.sessionList = [];
      let data = {}
      this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    });
  }
 
  switchSession(k){
    let data = {};
    data['message'] = "Switch to " +k.SnName;
    data['title'] = 'Switch Session';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        sessionStorage.setItem("session",JSON.stringify(k));
      this.mysecret();
      }
    });
  }
  mysecret(){
    this.umsService.getsecreat('').subscribe(res => {
      this.currentsession = sessionStorage.getItem("session");
      if(this.currentsession == null){
        this.umsService.secret(res.projectPharam);
      }else{
        let data = JSON.parse(this.currentsession)
        res.projectPharam['SnCode'] = data['SnCode']
        res.projectPharam['SnDefault'] =  data['SnDefault']
        res.projectPharam['SnName'] =  data['SnName']
        res.projectPharam['SnNo'] =  data['SnNo']
        res.projectPharam['SnStatus'] =  data['SnStatus']
        res.projectPharam['SnYear'] =  data['SnYear']
        this.umsService.secret(res.projectPharam);
      }
    });
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  fetchCodeType(id) {
    const payload = {};
    payload['CdType'] = 'SN';
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe(res => {
      if (res.status) {
        this.codeTypeList = res.data;
        this.filteredCodeType = this.codeTypeList.slice();
      }
    },(ERROR: HttpErrorResponse) => {
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  sessionName(name) {
    let payload = this.SessionForm.value;
    if(payload.SnYear >= 1800 && payload.SnYear <= 2100){
      if (name == 'First Half') {
        this.SessionForm.controls["SnName"].setValue(name + ', ' + payload.SnYear);
      }
      else if (name == 'Second Half') {
        this.SessionForm.controls["SnName"].setValue(name + ', ' + payload.SnYear);
      }
      else if (name == 'First Half-Re') {
        this.SessionForm.controls["SnName"].setValue(name + ', ' + payload.SnYear);
      }
      else if (name == 'Second Half-Re') {
        this.SessionForm.controls["SnName"].setValue(name + ', ' + payload.SnYear);
      }
      else {
        this.SessionForm.controls["SnName"].setValue('');
      }
    }
    
  }

  sessionName2(){
    let payload = this.SessionForm.value;
    if(payload.SnYear >= 1800 && payload.SnYear <= 2100){
      if (payload.SnCode == 'F') {
        this.SessionForm.controls["SnName"].setValue('First Half' + ', ' + payload.SnYear);
      }
      else if (payload.SnCode == 'S') {
        this.SessionForm.controls["SnName"].setValue('Second Half' + ', ' + payload.SnYear);
      }
      else if (payload.SnCode == 'FR') {
        this.SessionForm.controls["SnName"].setValue('First Half-Re' + ', ' + payload.SnYear);
      }
      else if (payload.SnCode == 'SR') {
        this.SessionForm.controls["SnName"].setValue('Second Half-Re' + ', ' + payload.SnYear);
      }
      else {
      }
    }
  }

  codeTypeClick(value)
  {
   this.desLabel = value;
  }


  addnewrecord() { 
    const dialogRef = this.dialog.open(SessionDataDialogBoxComponent, {
      width: '120vh',
      data: {key : "New"},
      disableClose: true  
    });  
    dialogRef.afterClosed().subscribe(result => {
      this.getSessionData();
      this.SessionSearchForm.controls['SearchString'].setValue('');
    });
  }

  editData(k){
    const dialogRef = this.dialog.open(SessionDataDialogBoxComponent, {
      width: '120vh',
      data: { selected: k, key : "Edit"},
      disableClose: true 
    });
    dialogRef.afterClosed().subscribe(result => { 
      // Handle dialog close actions or data 
        this.getSessionData();
        this.SessionSearchForm.controls['SearchString'].setValue('');
    });
  }
 
}
